<template>
    <div>
        <b-modal id="location_details_modal" title="Details" ref="location_details_modal" :okOnly="true" :okTitle="uLang('app.close')">
            <rea-loader :loading="location === null"/>

            <table class="table custom-stripe borderless" v-if="location !== null">
                <tr>
                    <td width="130">{{ uLang('app.name') }}: </td>
                    <td>{{ location.name }}</td>
                </tr>
                <tr>
                    <td>{{ uLang('app.description') }}: </td>
                    <td>{{ location.description }}</td>
                </tr>
                <tr>
                    <td>{{ uLang('app.address_type') }}: </td>
                    <td>{{ location.addresses[0].type.value }}</td>
                </tr>
                <tr>
                    <td>{{ uLang('app.address') }}: </td>
                    <td>{{ location.addresses[0].street + ' ' + location.addresses[0].house_number }}</td>
                </tr>
                <tr>
                    <td>{{ uLang('app.zipcode') }}: </td>
                    <td>{{ location.addresses[0].zipcode }}</td>
                </tr>
                <tr>
                    <td>{{ uLang('app.city') }}: </td>
                    <td>{{ location.addresses[0].city }}</td>
                </tr>
                <tr>
                    <td>{{ uLang('app.country') }}: </td>
                    <td>{{ location.addresses[0].country.name }}</td>
                </tr>
            </table>
        </b-modal>
    </div>
</template>
<script>
    import Vue from "vue";
    import { ReaLoader } from '~/components/helpers'

    export default {
        name: "modal-location",

        props: {
            resource: {
                required: true,
            },
            resourceId: {
                required: true,
            },
        },

        components: {
            'rea-loader': ReaLoader,
        },

        data(){
            return{
                location: null,
                id: 0
            }
        },

        created: function () {
            if(this.id != 0){
                this.retrieveLocation();
            }
        },

        methods: {
            async retrieveLocation(id) {
                this.id = id;
                const { data } = await window.axios.get(route('resource.locations.show', {
                    resource: this.resource,
                    resource_id: this.resourceId,
                    location: this.id,
                }));

                this.location = data;

                this.$refs.location_details_modal.show();
            },
        },
    }
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped>
    .table.borderless th,
    .table.borderless td,
    .table.borderless {
        border: 0;
    }
</style>